import {ControlledDragAndDropFiles, LabelRegular} from '@hm/fundamental'
import {useState} from 'react'

import {useRiskSurveyTranslation} from '../../hooks'

type ExcelDropzoneProps = {
  onFileSelected: (file: File) => void
  isLoading: boolean
}

export const ExcelDropzone = ({onFileSelected, isLoading}: ExcelDropzoneProps) => {
  const {t} = useRiskSurveyTranslation()
  const [files, setFiles] = useState<File[]>([])

  return (
    <div className="p-4">
      <LabelRegular className="mb-4">{t('import.dropzoneHint')}</LabelRegular>
      <ControlledDragAndDropFiles
        name="excelUpload"
        hint={t('import.dropzoneLabel')}
        multiple={false}
        value={files}
        onChange={(newFiles) => {
          const file = newFiles?.[0]
          if (file instanceof File) {
            setFiles([file])
            onFileSelected(file)
          }
        }}
        accept=".xlsx"
        disabled={isLoading}
        data-cy="excel-dropzone"
      />
    </div>
  )
}
